import React from 'react';
import PlainClientSynthesis from './PlainClientSynthesis';
import RichReportRenderer from './RichReportRenderer';
import NexusReportRenderer from './NexusReportRenderer';

// Compatibility wrapper retains the existing CSS while using saved source only.
// No presentation requests, generated fragments, sanitizer or reconstruction.
export default function FormattedReport({ reportType, content, testId, ...controls }) {
  if (reportType === 'client_synthesis') return <PlainClientSynthesis content={content} testId={testId} />;
  return <div className={`phase5-report formatted-report formatted-report-${reportType}`}>
    {reportType === 'nexus'
      ? <NexusReportRenderer preserveSourceText content={content} testId={testId} {...controls} />
      : <RichReportRenderer preserveSourceText content={content} testId={testId} reportKey={reportType} {...controls} />}
    <style>{`.formatted-report .phase5-section-badge {display:none;} .formatted-report .insight-why-section-content p {margin:0 0 1em;} .formatted-report .insight-why-section-content h3, .formatted-report .insight-why-section-content h4 {margin:1.2em 0 .5em;} .formatted-report blockquote {border-left:3px solid #2c7a7b; padding-left:1em; margin:1em 0;} .formatted-report li {margin-bottom:1em;}`}</style>
  </div>;
}
